var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "btn-morespins",
    on: {
      "click": _vm.showPopMoreSpins
    }
  }), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popMoreSpinsClass",
      "show": _vm.popMoreSpinsShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popMoreSpinsShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-morespins"
  }, [_c('div', {
    staticClass: "pop-morespins__title"
  }, [_vm._v("Number of spins")]), _c('div', {
    staticClass: "pop-morespins-list"
  }, [_c('transition-group', {
    staticClass: "pop-morespins-scroll",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.spinsPriceList && !_vm.isLoading ? _vm._l(_vm.spinsPriceList, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "pop-morespins-item",
      class: [index == 1 && 'popular', index == _vm.spinsPriceList.length - 1 && 'best'],
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.selectPaySpins(item, index);
        }
      }
    }, [index == 1 || index == _vm.spinsPriceList.length - 1 ? _c('div', {
      staticClass: "pop-morespins-item-tag"
    }) : _vm._e(), _c('div', {
      staticClass: "pop-morespins-item-main"
    }, [_c('div', {
      staticClass: "pop-morespins-item__num"
    }, [_vm._v(_vm._s(_vm.fmt_pre(item.baseCount)) + " Spins")]), _c('div', {
      staticClass: "pop-morespins-item__sub"
    }, [_vm._v(_vm._s(item.count - item.baseCount > 0 ? 'Bonus +' + _vm.fmt_pre(item.count - item.baseCount) + ' Spins' : ''))]), _c('div', {
      staticClass: "pop-morespins-item-info"
    }, [_vm.taskInfo.paymentInfo[`p_${index}`].isLoading || item.isLoading ? _c('div', {
      staticClass: "loading"
    }, [_c('div', {
      staticClass: "circleLoading"
    })]) : [_c('div', {
      staticClass: "pop-morespins-item-info__price"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-usdt.png'),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(item.usd)))])])]], 2)])]);
  }) : _vm._e()], 2)], 1)])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "title": "Select payment method",
      "isClose": false,
      "isBtnCancel": false,
      "isBtnConfirm": false,
      "show": _vm.popPromptShow,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popPromptShow = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "error",
      fn: function () {
        return [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('error') && _vm.popPromptInfo.error ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.popPromptInfo.error)
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pop-common"
  }, [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('title') && _vm.popPromptInfo.title ? _c('div', {
    staticClass: "pop-common__title"
  }, [_vm._v(_vm._s(_vm.popPromptInfo.title))]) : _vm._e(), _vm.selectItem ? _c('div', {
    staticClass: "pop-common__pay"
  }, [_c('div', {
    staticClass: "pop-common__pay-item",
    class: _vm.payType == 0 && 'active',
    on: {
      "click": function ($event) {
        return _vm.onPaySpinsSelect(_vm.selectItem, 0);
      }
    }
  }, [_c('div', {
    staticClass: "pop-common__pay-btn"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.selectItem.stars)))])])]), _c('div', [_vm._v("OR")]), _c('div', {
    staticClass: "pop-common__pay-item",
    class: _vm.payType == 1 && 'active',
    on: {
      "click": function ($event) {
        return _vm.onPaySpinsSelect(_vm.selectItem, 1);
      }
    }
  }, [_c('div', {
    staticClass: "pop-common__pay-btn"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-ton.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.selectItem.ton)))])])])]) : _vm._e(), _vm.payType !== null ? _c('div', {
    staticClass: "pop-common__pay-next"
  }, [_vm.payType == 1 ? [!_vm.tonConnect ? _c('div', {
    staticClass: "pop-common__pay-next-btn",
    on: {
      "click": function ($event) {
        return _vm.onTonConnect();
      }
    }
  }, [_vm._v("Connect")]) : _vm._e(), _vm.tonConnect && _vm.ispay ? _c('div', {
    staticClass: "pop-common__pay-next-btn",
    on: {
      "click": function ($event) {
        return _vm.doCheck();
      }
    }
  }, [_vm._v("Check")]) : _vm._e(), _vm.tonConnect ? _c('div', {
    staticClass: "pop-common__pay-next-btn",
    on: {
      "click": function ($event) {
        return _vm.doPayment(1);
      }
    }
  }, [_vm._v("Payment")]) : _vm._e()] : [_vm.ispay ? _c('div', {
    staticClass: "pop-common__pay-next-btn",
    on: {
      "click": function ($event) {
        return _vm.doCheck();
      }
    }
  }, [_vm._v("Check")]) : _vm._e(), _c('div', {
    staticClass: "pop-common__pay-next-btn",
    on: {
      "click": function ($event) {
        return _vm.doPayment(0);
      }
    }
  }, [_vm._v("Payment")])]], 2) : _vm._e()])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };